import React from 'react';
import { useAxios } from './useAxios';

/**
 * Treat URL as 3rd party.
 * Date source: {@link https://docs.google.com/spreadsheets/d/1TfVdvqyPz93JOJa_28ZbMZWApwe1VhYegRpthJAz5E0/edit?gid=0#gid=0}
 */
const metricsUrl = `${process.env.REACT_APP_BACKEND}/getSheet?sheet=1TfVdvqyPz93JOJa_28ZbMZWApwe1VhYegRpthJAz5E0&sheetName=Component%20List`;

type YesOrNo = 'Yes' | 'No';
type NumericString = `${number}`;
export interface Metric {
  Category: string;
  'Component Name': string;
  Designed: YesOrNo;
  Developed: YesOrNo;
  '# of Integrations': NumericString;
  'Component Size': NumericString;
  'Component Size Gzip': NumericString;
  Admin: NumericString;
  Benchmark: NumericString;
  'Case Management': NumericString;
  'XI Powered Apps (cxic)': NumericString;
  'Data Exploration': NumericString;
  'Exec Reporting': NumericString;
  'Field Reporting': NumericString;
  MXIC: NumericString;
  SEO: NumericString;
  Shared: NumericString;
  'System Management': NumericString;
  Login: NumericString;
  'Angular (Other)': NumericString;
  'Invitation Management': NumericString;
  Reporting: NumericString;
  'Campaign Insights': NumericString;
  Survey: NumericString;
  'Text Analytics': NumericString;
  Workflow: NumericString;
  Lexalytics: NumericString;
}

export function useMetrics() {
  const [metrics, setMetrics] = React.useState<Metric[]>([]);
  useAxios<Metric[]>(metricsUrl, setMetrics, () => {});
  return metrics;
}
